import * as Status from '../../../constants/status';

export const DIGITADOR_BATCH_STATUSES = [
  Status.INSPECAO_FINALIZADA,
  Status.AGUARDANDO_DIGITACAO,
];

export const INSPETOR_BATCH_STATUSES = [
  Status.EM_CRIACAO,
  Status.AGUARDANDO_INSPECAO,
  Status.INSPECAO_ENVIADA_PARCIAL,
];

export const isDigitadorBatchStatus = (status) =>
  DIGITADOR_BATCH_STATUSES.includes(status);

export const isInspetorBatchStatus = (status) =>
  INSPETOR_BATCH_STATUSES.includes(status);

export const countBatchEligibility = (selectedIds, statusById) => {
  let digitador = 0;
  let inspetor = 0;
  (selectedIds || []).forEach((id) => {
    const status = statusById.get(id) ?? statusById.get(String(id));
    if (isDigitadorBatchStatus(status)) digitador += 1;
    if (isInspetorBatchStatus(status)) inspetor += 1;
  });
  return {
    total: (selectedIds || []).length,
    digitador,
    inspetor,
  };
};

const isEligibleForKind = (status, kind) =>
  (kind === 'inspetor' ? isInspetorBatchStatus : isDigitadorBatchStatus)(status);

export const partitionBatchSelection = (selectedIds, statusById, kind) => {
  const eligibleIds = [];
  (selectedIds || []).forEach((id) => {
    const status = statusById.get(id) ?? statusById.get(String(id));
    if (isEligibleForKind(status, kind)) eligibleIds.push(id);
  });
  return {
    eligibleIds,
    ignoredCount: (selectedIds || []).length - eligibleIds.length,
  };
};

const formatAllowedStatusList = (kind) => {
  const statuses = kind === 'inspetor'
    ? INSPETOR_BATCH_STATUSES
    : DIGITADOR_BATCH_STATUSES;
  return statuses
    .map((status) => Status.STATUS_OPTIONS_DESCRIPTION[status] || status)
    .join(', ');
};

export const getBatchValidationMessage = (partition, kind) => {
  if (!partition?.ignoredCount) return null;
  return `Alguma NSIR selecionada não possui os status permitidos, que são ${formatAllowedStatusList(kind)}.`;
};

